import axios from 'utils/axiosInstance'

const BASE_URL_ENDPOINT = '/instrumentos/preguntas_por_grupo_interes'

const getPreguntaGrupoInteres = async (busqueda = '') => {
  const response = await axios.get(`${BASE_URL_ENDPOINT}/?search=${busqueda}`)
  return response.data
}

const getPreguntaGrupoInteresByfield = async (field, value) => {
  if (!field || !value) return []
  
  const response = await axios.get(`${BASE_URL_ENDPOINT}/?${field}=${value}`)
  return response.data
}

const crearPreguntaGrupoInteres = async (values) => {
  const { data, onSuccess: onSuccessMessage } = await axios.post(
    `${BASE_URL_ENDPOINT}/`,
    values,
  )
  return { data, onSuccessMessage }
}

const eliminarPreguntaGrupoInteres = async ({ id, grupo_interes__nombre }) => {
  const { onSuccess: onSuccessMessage } = await axios.delete(
    `${BASE_URL_ENDPOINT}/${id}`,
  )
  return { data: grupo_interes__nombre, onSuccessMessage }
}

const actualizarPreguntaGrupoInteres = async ({ id, values }) => {
  const { data, onSuccess: onSuccessMessage } = await axios.put(
    `${BASE_URL_ENDPOINT}/${id}/`,
    values,
  )
  return { data, onSuccessMessage }
}

export {
  getPreguntaGrupoInteres,
  crearPreguntaGrupoInteres,
  eliminarPreguntaGrupoInteres,
  actualizarPreguntaGrupoInteres,
  getPreguntaGrupoInteresByfield
}